import React from 'react';
import isEqual from 'lodash/isEqual';
import { i18n } from 'config/locales';
import ValidationElement from '../ValidationElement';
import Text from '../Text';

export default class Street extends ValidationElement {
  constructor(props) {
    super(props);

    this.state = {
      value: props.value,
    };

    this.handleError = this.handleError.bind(this);
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (!isEqual(nextProps.value, this.props.value)) {
      this.setState({
        value: nextProps.value,
      });
    }
  }

  handleError(value, arr) {
    const arr2 = arr.map((err) => {
      const returnErr = {
        code: `street.${err.code}`,
        valid: err.valid,
        uid: err.uid,
      };

      // this is a specific case for EN-4821 to allow a specific error message
      // for street.poBox.pattern but to fix street.poBox.required which
      // shouldn't be a locale since street.required is the proper locale
      if (err.code.includes('poBox') && !err.code.includes('pattern')) { returnErr.code = `street.${err.code.replace('poBox.', '')}`; }

      return returnErr;
    });

    // Take the original and concatenate our new error values to it
    return this.props.onError(value, arr2);
  }

  label() {
    if (this.props.label && this.props.optional) {
      return (
        <span>
          {this.props.label}
          <span className="optional">{i18n.t('address.us.street2.optional')}</span>
        </span>
      );
    }

    return this.props.label;
  }

  render() {
    let changeablePlaceholder = this.props.placeholder;
    if (this.props.showDisabledText && this.props.value && this.props.disabled) {
      changeablePlaceholder = this.props.value;
    }

    const label = this.label();
    const props = {
      name: this.props.name,
      className: this.props.className,
      ariaLabel: this.props.label,
      label,
      placeholder: changeablePlaceholder,
      value: this.state.value,
      onUpdate: this.props.onUpdate,
      onError: this.handleError, // eslint-disable-line @typescript-eslint/unbound-method
      onFocus: this.props.onFocus,
      onBlur: this.props.onBlur,
      required: this.props.required,
      disabled: this.props.disabled,
      attribute: this.props.attribute,
      setToUpperCaseOnBlur: true,
    };

    if (!this.props.isPoBoxAllowed) {
      props.pattern = /^((?!PO Box|P.O. Box|Post Office Box).)*$/i;
      props.prefix = 'poBox';
    }

    return <Text {...props} />;
  }
}

Street.defaultProps = {
  value: '',
  label: '',
  optional: false,
  onUpdate: (queue) => { },
  onError: (value, arr) => arr,
  showDisabledText: false,
};

Street.errors = [];
